import { keepPreviousData, useQuery } from '@tanstack/react-query'
import { useTranslation } from 'react-i18next'
import { getActivities } from '../api/activityApi'
import type { ActivityQuery } from '../types'

/**
 * Sayfalı etkinlik listesi. Dil değişince ad'lar için yeniden çeker. {@code keepPreviousData}: sayfa
 * değişince tablo boşalıp titremez.
 */
export function useActivities(query: ActivityQuery) {
  const { i18n } = useTranslation()
  return useQuery({
    queryKey: ['activities', i18n.language, query],
    queryFn: () => getActivities(query),
    placeholderData: keepPreviousData,
  })
}
